export default __webpack_public_path__ + "images/image1.b0bbb7bb.png";